/*
  Elmaire behaviour. Shrine's VariantRadios never updates the "Color <value>" legend, so the label kept the first
  variant after a change; this keeps each fieldset's [data-selected-value] in step with its checked input.
*/

document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
  const fieldset = input.closest('variant-radios fieldset, variant-selects fieldset');
  const label = fieldset && fieldset.querySelector('[data-selected-value]');
  if (label) label.textContent = input.value;
});
